import { useCallback, useEffect, useMemo, useState } from 'react';
import { getPointTasksStats } from '../../../../auth/_requests';
import type { PointTasksStats, PointCategoryName } from '../../../../helpers/utils/types';

const EMPTY_STATS: PointTasksStats = { totalTasks: 0, totalCompleted: 0, categories: [] };

export type RewardsPointTaskStatsState = {
  loading: boolean;
  stats: PointTasksStats;
  error?: string;
};

export const usePointTaskStats = (opts: {
  token?: string;
  enabled: boolean;
  pointCategoryName?: PointCategoryName;
}) => {
  const { token, enabled, pointCategoryName } = opts;
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState<PointTasksStats>(EMPTY_STATS);
  const [error, setError] = useState<string | undefined>(undefined);

  const fetchStats = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    setError(undefined);
    try {
      const res = await getPointTasksStats(token, pointCategoryName);
      setStats(res ?? EMPTY_STATS);
    } catch (e) {
      console.error('Error fetching point task stats for rewards overview:', e);
      setStats(EMPTY_STATS);
      setError(e instanceof Error ? e.message : 'Unknown error');
    } finally {
      setLoading(false);
    }
  }, [token, pointCategoryName]);

  useEffect(() => {
    if (!enabled) return;
    fetchStats();
  }, [enabled, fetchStats]);

  return useMemo<RewardsPointTaskStatsState>(() => ({ loading, stats, error }), [loading, stats, error]);
};

